import { NgModule } from '@angular/core';
import { AuthModule, EventTypes, LogLevel } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';
import { PublicEventsService } from 'angular-auth-oidc-client';
import { filter, flatMap } from 'rxjs';
import { DaoService } from '../dao/dao.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from './auth.service';

const endpoints = environment.endpoints;
const authority = environment.keycloack.authority;

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        postLoginRoute: '/home',
        forbiddenRoute: '/forbidden',
        unauthorizedRoute: '/unauthorized',
        logLevel: LogLevel.Error,
        historyCleanupOff: false,
        authority: authority,
        redirectUrl: window.location.origin + "/home",
        postLogoutRedirectUri: window.location.origin,
        clientId: 'cloudprocessing-client',
        scope: 'openid profile email offline_access',
        responseType: 'code',
        silentRenew: true,
        silentRenewUrl: `${window.location.origin}/silent-renew.html`,
        //useRefreshToken: true,
        secureRoutes: [endpoints['Luigi.Service'], endpoints['Luigi.Worker.Sevice']],
        tokenRefreshInSeconds: 10
      },
    }),
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {

  isSyncing: boolean = false;

  constructor(
    private eventService: PublicEventsService,
    private dao: DaoService,
    private toastr: ToastrService,
    private authService: AuthService,
    private loader: NgxUiLoaderService) {
    this.registerEvents();
  }

  registerEvents() {
    this.eventService
      .registerForEvents()
      .pipe(
        filter((notification) => notification.type === EventTypes.NewAuthenticationResult))
      .subscribe((value: any) => {
        //Get Authorization and Sync Orders on user Authentication
        this.authService.setAuthorizationToken();
        if (!this.isSyncing)
          this.sync();
      });

    this.eventService
      .registerForEvents()
      .pipe(
        filter((notification) => notification.type === EventTypes.CheckingAuthFinished))
      .subscribe((value: any) => {
        this.authService.getRealmAuthorization();

      });
  }


  sync() {
    this.isSyncing = true;
    this.authService.sync(true, true)
      .subscribe(
        result => {

        },
        error => {
          //this.toastr.error("Sync Orders Error, please reload the page");
        }, () => {
          this.isSyncing = false;
        })
  }
}
